import {  toZonedTime  } from 'date-fns-tz';
import { parseISO,format, intervalToDuration,isToday, isBefore, formatDistanceToNow, isSameDay, parse, isEqual, differenceInMilliseconds, addMinutes } from 'date-fns';

export function convertToLocalTimezone(param){
    const dateInUtc = new Date(param);
    // const localDate = toZonedTime(dateInUtc, localTimezone());
    return dateInUtc;
}
export function localTimezone(){
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

// export function timeFormat(time, format = "H:i A") {
//     return format(parse(time, "HH:mm:ss", new Date()), "p");
// }



/**
 * Convert UTC date to local date
 * @param {number} utc_date - UTC date
 * @param {boolean} time - Whether to include time
 * @returns {string} Local date
 */
export function dateFormatToLocal(utc_date, time = true) {
    const args = {
      year: "numeric",
      month: "short",
      day: "numeric"
    }
    if (time) {
      args.hour = "2-digit";
      args.minute = "2-digit";
      args.hour12 = true;
    }
    return new Date(utc_date).toLocaleDateString('en-US', args);
}

export function dateFormat(
    date,
    from_format = "yyyy-MM-dd",  
    to_format = "dd/MM/yyyy"     
) {
    if (!date) {
        return "<i>N/A</i>";
    }
    // if (locale == "en") {
    //     to_format = "MM/dd/yyyy";
    // }
    let parsedDate;
    
    // Check if it's an ISO 8601 string (contains 'T' or 'Z')
    if (typeof date === 'string' && (date.includes('T') || date.includes('Z'))) {

        parsedDate = parseISO(date);
    } else {
        parsedDate = parse(date, from_format, new Date());
    }
    return format(parsedDate, to_format);
}

export function dateTimeHumanize(dateTime) {
    if (dateTime) {
        return formatDistanceToNow(new Date(dateTime), { addSuffix: true });
    }
    return null;
}

// export function dateTimeFormat(dateTime) {
//     const from_format = "YYYY-MM-DD";
//     let to_format = "DD/MM/YYYY hh:mm A";
//     if (locale == "en") {
//         to_format = "MM/DD/YYYY hh:mm A";
//     }
//     const client_tz = localTimezone();
//     return format(toZonedTime(new Date(dateTime), client_tz), to_format);
// }

export function utcToHumanize(dateTime, timezone = null) {
    if (!dateTime) {
        return null;
    }
    
    // Parse the input datetime (assumes it's in UTC or ISO format)
    const utcDate = typeof dateTime === 'string' ? parseISO(dateTime) : dateTime;
    let zonedDate;
    
    if (timezone) {
        // Convert UTC to specified timezone
        zonedDate = toZonedTime(utcDate, timezone);

    } else {
        // Use client's local timezone (no conversion needed, date-fns uses local by default)
        zonedDate = utcDate;
    }
    
    let result;
    
    if (isToday(zonedDate)) {
        // If it's today, return humanized string (e.g., "2 hours ago")
        result = formatDistanceToNow(zonedDate, { addSuffix: true });
    } else {
        // If not today, return formatted date and time in 24-hour format
        result = format(zonedDate, 'dd-MM-yyyy HH:mm');
    }
    
    // Capitalize the first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
}
export const showRemainingDays = (remainingMinutes) => {
    if (isNaN(remainingMinutes) || remainingMinutes < 0) {
        return 'Invalid input';
    }

    const start = new Date();
    const end = addMinutes(start, remainingMinutes);
    const duration = intervalToDuration({ start, end });

    const days = duration.days || 0;
    const hours = duration.hours || 0;
    const minutes = duration.minutes || 0;

    let result = `${days > 0 ? `${days} day${days > 1 ? 's' : ''}` : ''}`;
    result += hours > 0 ? ` ${hours} hour${hours > 1 ? 's' : ''}` : '';
    result += minutes > 0 ? ` ${minutes} minute${minutes > 1 ? 's' : ''}` : '';

    return result.trim() || "0 minutes";
}

// Format remaining time until expiry similar to backend expireTimeFormat
export function formatExpiredAt(expiredAt, isExpired = false) {
    if (!expiredAt) {
        return '';
    }

    if (isExpired) {
        return 'Site Expired';
    }

    const now = new Date();
    // Parse UTC date string (format: 'YYYY-MM-DD HH:mm:ss')
    // Convert to ISO format by replacing space with 'T' and appending 'Z' for UTC
    const expiry = parseISO(expiredAt.replace(' ', 'T') + 'Z');

    if (isBefore(expiry, now) || isEqual(expiry, now)) {
        return 'Site will be expired soon';
    }

    // Get duration between now and expiry
    const duration = intervalToDuration({ start: now, end: expiry });

    const parts = [];

    if (duration.years > 0) {
        parts.push(`${duration.years} year${duration.years > 1 ? 's' : ''}`);
    }
    
    if (duration.months > 0) {
        parts.push(`${duration.months} month${duration.months > 1 ? 's' : ''}`);
    }

    if (duration.days > 0) {
        parts.push(`${duration.days} day${duration.days > 1 ? 's' : ''}`);
    }

    if (duration.hours > 0) {
        parts.push(`${duration.hours} hour${duration.hours > 1 ? 's' : ''}`);
    }

    if (duration.minutes > 0) {
        parts.push(`${duration.minutes} min${duration.minutes > 1 ? 's' : ''}`);
    }

    if (!parts.length) {
        const seconds = duration.seconds ?? 0;
        return `${seconds} second${seconds !== 1 ? 's' : ''}`;
    }

    return parts.join(', ');
}

export function getExpiryPercentage(expiredAt, allowedDays) {
    // Parse the date string as UTC (format: 'YYYY-MM-DD HH:mm:ss')
    // Convert to ISO format by replacing space with 'T' and appending 'Z' for UTC
    const expiryDate = parseISO(expiredAt.replace(' ', 'T') + 'Z');
    const nowUtc = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = differenceInMilliseconds(expiryDate, nowUtc);
    const totalAllowedTimeInMs = allowedDays * 24 * 60 * 60 * 1000;

    // Calculate the percentage
    const percentage = (diffInMs / totalAllowedTimeInMs) * 100;

    // Ensure the percentage is not less than 0 or more than 100
    const validPercentage = Math.max(0, Math.min(percentage, 100));

    return 100 - validPercentage;
}